import useSWR from 'swr'

// libs
import { apiGetService, apiHandleError } from '@/lib'

// types
import { SWRKeys, SWRFetcherData } from './types'

const getPublicTracksByIds = async ({
  data: { trackIds },
}: SWRFetcherData<{ trackIds: string[] }>) => {
  // get api service
  const api = apiGetService()

  // if no track ids provided
  if (trackIds.length === 0) {
    // return empty payload
    return { tracks: [], count: 0, error: '' }
  }

  try {
    // retrieve public tracks
    const { tracks, count } = await api.trackApi.getPublicTracksByIds(trackIds.join(','))

    // return payload
    return { tracks, count, error: '' }
  } catch (err: any) {
    const { message } = await apiHandleError(err)

    // return error
    return { tracks: [], count: 0, error: message }
  }
}

const fetcher = (args: SWRFetcherData<{ trackIds: string[] }>) =>
  getPublicTracksByIds(args)

export const useTracksPublic = (trackIds: string[]) => {
  const { data, isLoading } = useSWR(
    { key: SWRKeys.UseTracksPublic, data: { trackIds } },
    fetcher,
    { revalidateOnFocus: false },
  )

  return {
    tracks: data?.tracks,
    count: data?.count,
    isLoading,
    isError: data?.error,
  }
}
